import styled from 'styled-components'

export const ContainerCampo = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
`

export const ContainerBotaoOpcional = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    flex-direction: column;
`

export const ContainerItemCadastro = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 25px;
    @media (max-width: 950px) {
        flex-direction: column;
        gap: 20px;
    }
`

export const ContainerListaFiltros = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`

export const ContainerLinhaFiltro = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: minmax(180px, 1fr) minmax(220px, 1fr) auto;
    align-items: end;
    gap: 25px;
    @media (max-width: 950px) {
        grid-template-columns: 1fr;
        gap: 20px;
    }
`

export const ContainerAcoesLinha = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-width: 96px;
    min-height: 38px;
    @media (max-width: 950px) {
        justify-content: flex-start;
        min-width: 0;
    }
`
